<template>
  <div class="container">
    <div>
      <div class="p-3">
        <b-loading
          :is-full-page="true"
          v-model="loading"
          :can-cancel="true"
        ></b-loading>
        <div v-if="!loading">
          <div class="mb-5">
            <router-link to="/planned-trips" class="has-text-weight-bold"
              >Trips</router-link
            >
            >
            <router-link
              :to="{
                name: 'trip-detail',
                params: {
                  recordLocator: this.trip.recordLocator,
                  tripProp: trip,
                },
              }"
              class=""
              >Trip Details</router-link
            >
            > <span class="has-text-weight-light">Cancel Flight</span>
          </div>
          <b-icon icon="arrow_left" size=""></b-icon>

          <div class="box mb-5 p-5">
            <div class="columns is-centered">
              <div class="column is-narrow mt-1">
                <b-icon icon="wallet-travel mt-6" size="is-medium"></b-icon>
              </div>
              <div class="column">
                <b-collapse
                  aria-id="contentIdForA11y2"
                  class="type-panel mb-6"
                  animation="slide"
                  v-if="tst.segments.length"
                >
                  <template #trigger>
                    <div
                      class="section-title is-size-4 has-text-weight-medium"
                      role="button"
                      aria-controls="contentIdForA11y2"
                    >
                      Your Flight Reservation
                    </div>
                  </template>
                  <div class="section-body">

                    <NDCTag v-if="this.trip.isNdcBooking"
                      class="mb-5"
                      position="is-right"
                    ></NDCTag>

                    <div class="my-3 is-size-7 has-text-weight-medium">
                      <span class="is-uppercase has-text-grey">
                        Ticket Number:
                      </span>
                      <span v-if="ticketNumber">{{ ticketNumber }}</span
                      ><span v-else class="">Not Ticketed</span>
                    </div>

                    <div v-for="(segment, index) in tst.segments" :key="index">
                      <li>
                        {{ $helpers.getAirportLocation(segment.origin) }} ({{
                          segment.origin
                        }}) to
                        {{ $helpers.getAirportLocation(segment.destination) }}
                        ({{ segment.destination }}) on
                        {{ segment.startDate.date | formatDate }} at
                        {{ segment.startDate.time | formatTime }}

                        (Flight # {{ segment.airline }}
                        {{ segment.flightNumber }})
                      </li>
                    </div>

                    <div class="my-6" v-if="tst.fare">
                      <div class="columns is-mobile">
                        <div class="column is-narrow">
                          <div>Base Fare:</div>
                          <div>Taxes:</div>
                          <div class="has-text-weight-bold">Total Fare:</div>
                        </div>
                        <div class="column is-narrow has-text-right">
                          <div>
                            {{ tst.fare.base | formatPriceFromDollars(2) }}
                          </div>
                          <div>
                            {{ tst.fare.tax | formatPriceFromDollars(2) }}
                          </div>
                          <div class="has-text-weight-bold">
                            {{ tst.fare.total | formatPriceFromDollars(2) }}
                          </div>
                        </div>
                        <div class="column"></div>
                      </div>
                    </div>

                    <div class="cancel-section">
                      <hr />
                      <div class="is-size-5 mb-4">
                        Cancellation Details:
                      </div>

                      <ul v-if="!isTicketed">
                        <li>
                          This reservation has not yet been ticketed by the
                          airline and is eligble for immediate cancellation
                          prior to ticketing.
                        </li>
                      </ul>

                      <ul v-else-if="isTicketed && isVoidable">
                        <li>
                          To receive a full refund for your flight, you must
                          cancel within 24 hours of booking.
                        </li>
                        <li>
                          {{ $helpers.getAirlineName(tst.airlineCode) }}
                          will refund your original form of payment within 7-10
                          days.
                        </li>
                        <li>
                          Your refund will include only the fare purchased
                          through Trip Circuit. If you made any additional
                          purchases from the airline, please contact the airline
                          directly.
                        </li>
                      </ul>

                      <ul v-else-if="isTicketed && !isVoidable">
                        <li>
                          Most flights are refundable for up to 24 hours from
                          the initial purchase.
                        </li>
                        <li>
                          Flights cancelled after 24 hours may be eligible for
                          credit towards a future flight, minus any fees and
                          penalties charged by the airline.
                        </li>
                      </ul>

                      <button
                        v-if="showCancel && !cancelDialog"
                        class="button is-info mt-4 is-small"
                        @click="cancelDialog = true"
                      >
                        <span v-if="isTicketed && !isVoidable"
                          >Cancel and request flight credit
                        </span>
                        <span v-else>Cancel This Flight </span>
                      </button>

                      <div class="my-5" v-if="cancelDialog">
                        <div class="mt-4 mb-2 has-text-danger">
                          Are you sure you wish to cancel this booking? This
                          action cannot be undone.
                        </div>
                        <button
                          class="button is-info mt-4 is-small"
                          @click="submitFlightCancel"
                        >
                          Yes, Cancel My Flight
                        </button>
                        <button
                          class="button is-info mt-4 ml-2 is-outlined is-small"
                          @click="cancelDialog = false"
                        >
                          Do Not Cancel
                        </button>
                      </div>

                      <b-progress
                        v-if="cancelLoader"
                        type="is-success my-2"
                        style="max-width: 300px"
                      ></b-progress>

                      <div class="mt-4 mb-2 has-text-danger">
                        {{ cancelMessage }}

                        <ul v-if="cancelErrors.length">
                        <li
                          v-for="(error, eIndex) in cancelErrors"
                          :key="eIndex"
                        >
                          {{ error.title }} ({{ error.code }})
                      </li>
                      </ul>

                      </div>
                    </div>
                  </div>
                </b-collapse>

                <!-- Start segment -->
              </div>
            </div>

            <!--
            <b-modal v-model="modalActive" :width="320" scroll="keep">
              <div class="card bg-white p-4">
                <header class="card-header">
                  <p class="card-header-title"></p>
                  <button
                    class="delete"
                    aria-label="close"
                    @click="modalActive = false"
                  ></button>
                </header>

                <div v-if="cancelLoader" class="p-6">
                  <b-loading
                    :is-full-page="false"
                    v-model="cancelLoader"
                    :can-cancel="true"
                  ></b-loading>
                </div>

                <div v-else-if="cancelMessage">{{ cancelMessage }}</div>

                <div v-else>
                  <div class="mb-4 has-text-danger">
                    Are you sure you wish to cancel this booking? This action
                    cannot be undone.
                  </div>
                  <b-button class="is-danger mr-3" @click="voidTicket"
                    >Yes, cancel my booking</b-button
                  >

                  <b-button class="is-info" @click="modalActive = false"
                    >Exit</b-button
                  >
                </div>
              </div>
            </b-modal>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import NDCTag from "@/components/Tags/NDCTag.vue";

export default {
  name: "FlightCancel",
  components: {
    NDCTag,
  },
  props: {
    //a base64 encoded version of the actual Amadeus record locator;
    //used in the url for obscurity
    recordLocatorHash: {
      required: true,
      type: String,
    },
    id: {
      required: true,
      type: Number,
    },
    tripProp: {
      required: false,
      //type: Object,
    },
  },
  data() {
    return {
      details: {},
      ticket: {},
      tst: {},
      trip: {},
      error: {},
      loading: true,
      modalActive: false,
      cancelLoader: false,
      cancelMessage: null,
      cancelErrors: [],
      cancelResult: null,
      cancelDialog: false,
      showCancel: true,
    };
  },
  computed: {
    //convert the Base64 hash to the actual Amadeus record locator
    recordLocator() {
      return this.$helpers.decryptText(this.recordLocatorHash);
    },
    isTicketed() {
      return this.ticketNumber ? true : false;
    },
    ticketExpire() {
      return moment(this.trip.ticketElement.ticket.date, "DDMMYY").add(
        1,
        "days"
      );
    },
    isVoidable() {
      let now = moment();
      let expirationDate = this.ticketExpire;

      if (expirationDate.isAfter(now)) return true;
      else return false;
    },
    ticketNumber() {
      return this.tst.ticketNumber;
    },
    travellerProfile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
  },
  methods: {
    /*
    launchCancelModal(segment) {
      let config = {
        parent: this,
        component: CancellationModal,
        props: {
          segment: segment,
        },
        trapFocus: false,
        width: 900,
      };
      this.$buefy.modal.open(config);
    },
    */
    /*
    async getTicketInfo(ticketNumber) {
      var post = {
        meta: {
          stateful: true,
          sessionKey:
            "file:HuddleLabs/Amadeus/XmlObjects/Ticket/DisplayTicket.xml",
          normalizeResponse: true,
        },
        ticketNumber: this.ticketnumber,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/air/display-ticket",
        post
      );

      return result;
    },
    */
    reshopOrder(data) {
      return this.$app.huddleLabsServerCall(
        "amadeus/travel/order-reshop",
        data
      );
    },
    cancelOrder(data) {
      return this.$app.huddleLabsServerCall(
        "amadeus/travel/ndc-order-cancel",
        data
      );
    },
    retrieveOrder(data) {
      return this.$app.huddleLabsServerCall(
        "amadeus/travel/order-retrieve",
        data
      );
    },
    async submitFlightCancel() {
      if (this.trip.orderId) {
        this.cancelNdcOrder();
      } else if (this.isTicketed) {
        this.voidTicket();
      } else {
        this.pnrCancel(this.tst.segments);
      }
    },
    async cancelNdcOrder() {
      this.cancelLoader = true;
      const defaultError =
        "We experienced an error when trying to cancel this booking. Please contact Gant Travel at 877-924-0303 for further assistance. ";
      const orderId = this.trip.orderId;
      const ownerCode = this.trip.ownerCode;
      const meta = {
        stateful: false,
        sessionKey: null,
        normalizeResponse: true,
      };

      const retrieveOrderResponse = await this.retrieveOrder({
        meta,
        orderId,
        ownerCode,
      });

      if (retrieveOrderResponse.errors?.length) {
          this.cancelMessage = defaultError;
          this.closeCancel();
          return this.cancelErrors = retrieveOrderResponse.errors;          
        }

      if (retrieveOrderResponse.data) {
        const order = retrieveOrderResponse.data;

        const reshopOrderResponse = await this.reshopOrder({
          meta,
          orderId,
          airlineCode: ownerCode,
          deleteItems: order.items.map((item) => ({ itemId: item.itemId })),
        });

        if (reshopOrderResponse.errors?.length) {
          this.cancelMessage = defaultError;
          this.closeCancel();
          return this.cancelErrors = reshopOrderResponse.errors;          
        }

        var post = {
          meta,
          ticketNumber: this.ticketNumber,
          recordLocator: this.recordLocator,
          cancelItinerary: false,
          segments: this.tst.segments.map((x) => x.tattoo),
          requester: this.travellerProfile.email,
          orderId,
          ownerCode,
        };

        const cancelOrderResponse = await this.cancelOrder(post);

        if (cancelOrderResponse.errors?.length) {
          this.cancelMessage = defaultError;
          this.closeCancel();
          return this.cancelErrors = cancelOrderResponse.errors;
        }


        this.cancelMessage = cancelOrderResponse.meta?.message || "Reservation has been successfully canceled.";

      }   

      this.closeCancel();
    },
    async pnrCancel(segments) {
      this.cancelLoader = true;
      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/Pnr_Cancel_Flight.xml",
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/Pnr_Cancel_Fail.xml",
        },
        recordLocator: this.recordLocator,
        cancelItinerary: false,
        segments: segments.map((x) => x.tattoo),
        requester: this.travellerProfile.email,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/cancel-segment",
        post
      );

      if (result.status == "OK") {
        this.cancelMessage = "Reservation has been successfully canceled.";
      } else {
        this.cancelMessage =
          "We experienced an error when trying to cancel this booking. Please contact Gant Travel at 877-924-0303. ";

        let errmsg = this.$helpers.getSafe(() => result.messages[0].text);

        if (errmsg)
          this.cancelMessage +=
            " The following error message was received: " + errmsg;
      }

      this.closeCancel();
    },
    closeCancel() {
      this.cancelLoader = false;
      this.cancelDialog = false;
      this.showCancel = false;
    },
    async voidTicket() {
      this.cancelLoader = true;
      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Ticket/TicketCancelFail.xml",
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Ticket/TicketCancelSuccess.xml",
        },
        ticketNumber: this.ticketNumber,
        airlineStock: this.$helpers.getSafe(
          () => this.trip.ticketElement.ticket.airlineCode
        ),
        officeId: this.$helpers.getSafe(
          () => this.trip.ticketElement.ticket.officeId
        ),
        recordLocator: this.recordLocator,
        //segments: this.tst.segments,
        requester: this.travellerProfile.email,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/air/void-ticket",
        post
      );
      //this.cancelResult = result;

      if (
        result.status == "OK"
        //this.$helpers.getSafe(() => result.response.transactionResults.responseDetails.statusCode) == "O"
      ) {
        this.cancelMessage =
          result.message ?? "Booking has been successfully canceled.";
      } else {
        this.cancelMessage =
          "We experienced an error when trying to cancel this booking. Please contact Gant Travel at 877-924-0303. ";

        let errorMessage = this.getError(result);

        if (errorMessage)
          this.cancelMessage +=
            " The following error message was received: " + errorMessage;
      }
      this.cancelLoader = false;
    },
    getError(result) {
      //Amadeus ticket void error
      let errorFreetext = this.$helpers.getSafe(
        () =>
          result.response.transactionResults.errorGroup.errorWarningDescription
            .freeText
      );

      //Amadeus general error messages
      let msgText = this.$helpers.getSafe(() => result.messages[0].text);

      //Laravel error message
      let basicError = this.$helpers.getSafe(() => result.message);

      if (errorFreetext) return errorFreetext;
      else if (msgText) return msgText;
      else if (basicError) return basicError;
      else return null;
    },
    async getTrip() {
      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/FlightTST2-Ticketed.xml",
          normalizeResponse: true,
        },

        recordLocator: this.recordLocator,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/show",
        post
      );

      return result;
    },
    async init() {
      let result = await this.getTrip();
      this.trip = result.data;
      this.tst = this.trip.tstInfo.filter((tst) => tst.id == this.id)[0];
    },
  },
  watch: {
    async $route(to, from) {
      this.loading = true;
      await this.init();
      this.loading = false;
    },
  },

  //TO DO: Move loading to route watcher insted of mounted hook
  async mounted() {
    this.loading = true;

    if (this.tripProp && typeof this.tripProp === "object") {
      this.trip = this.tripProp;
      this.tst = this.trip.tstInfo.filter((tst) => tst.id == this.id)[0];
    } else {
      await this.init();
    }

    this.loading = false;
  },
};
</script>

<style>
ul {
  list-style-type: disc;
  margin-left: 25px;
}

.type-panel {
  border: 1px rgb(226, 223, 223) solid;
  border-radius: 6px;
}

.section-title {
  border-bottom: 1px solid #ddddde;
  padding: 24px 32px;
  position: relative;
  top: 1px;
}

.section-body {
  padding: 24px 32px;
  position: relative;
  top: 1px;
}
</style>
